import axios from 'axios';
import router from '@/router';
import store from '@/store';
import BaseUrl from '_conf/url';
import { LoadingBar, Message } from 'iview';
import Vue from "vue";

axios.defaults.baseURL = BaseUrl.apiUrl;
// http发出的请求拦截，加入token信息
axios.interceptors.request.use(
    config => {
        config.headers.lang = Vue.config.lang ;
        if (store.state.user.token) {
            // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.authorization = store.state.user.token;
            config.headers.app_id = store.state.user.myInfo.loginName;
        }
        if (config.method === 'get') {
            for (let key in config.params) {
                if (config.params[key] === '') {
                    delete config.params[key];
                }
            }
        }
        return config;
    },
    err => {
        LoadingBar.error();
        return Promise.reject(err);
    }
);
// http返回的响应拦截，检测错误信息
axios.interceptors.response.use(
    response => response.data,
    error => {
        Message.error({
            content: error.response.data.meta.code + ':' + error.response.data.meta.msg,
            duration: 60,
            closable: true,
        });
        switch (error.response.status) {
            case 401: // 权限相关
                if (
                    error.response.data.meta.code === 500408 ||
                    error.response.data.meta.code === 500409 ||
                    error.response.data.meta.code === 500410
                ) {
                    // 清空token
                    store.commit('user/setToken', '');
                    // 清掉lock
                    store.commit('app/setLockInfo', { routerName: '', isLock: false });
                    // router.replace({
                    //     path: 'login',
                    //     query: { redirect: router.currentRoute.fullPath }
                    // })
                    router.push({ name: 'login' });
                    return;
                }
        }
        console.error(error.response);
        //throw new Error(error.response.data.meta.msg);
        LoadingBar.error();
        return Promise.reject(error.response.data); // 返回接口返回的错误信息
        //return error.response.data;
    }
);
axios.$callAPI = async function(func) {
    let result = await func();
    if (result.meta.code === 200402) {
        // 更新jwt。。。
        store.state.user.token = result.data.jwt;
        result = await func();
    }

    if (result.meta.success) {
        return result.data;
    } else {
        Message.error({
            content: result.meta.code + ':' + result.meta.msg,
            duration: 60,
            closable: true,
        });
        LoadingBar.error();
        throw new Error(result.meta.msg);
    }
};

export default axios;
